module.exports = __webpack_public_path__ + "static/media/blue-green-tape.7df06bd7.png";